import React from 'react';
import { Badge, Box } from '@chakra-ui/react';
import { AuditoriaBadge, AuditoriaStatus } from '../types';
import { UI } from '../ui';

interface StatusBadgeProps {
  status?: AuditoriaStatus;
  badge?: AuditoriaBadge;
}

const STYLES: Record<AuditoriaBadge, { bg: string; color: string; dot: string; label: string }> = {
  red: { bg: UI.negSoft, color: UI.neg, dot: UI.neg, label: 'Divergência' },
  amber: { bg: UI.warnSoft, color: UI.warn, dot: UI.warn, label: 'Alerta' },
  green: { bg: UI.posSoft, color: UI.pos, dot: UI.pos, label: 'OK' },
};

const STATUS_TO_BADGE: Record<AuditoriaStatus, AuditoriaBadge> = {
  DIVERGENCIA: 'red',
  ALERTA: 'amber',
  OK: 'green',
};

// Estilo neutro para status/badge fora do enum (backend pode emitir valores inesperados).
const FALLBACK = { bg: UI.neutralSoft, color: UI.muted, dot: UI.faint, label: '—' };

/** Badge de status (🔴 Divergência / 🟡 Alerta / 🟢 OK). Aceita `status` ou `badge`. */
export function StatusBadge({ status, badge }: StatusBadgeProps) {
  const kind = badge ?? (status ? STATUS_TO_BADGE[status] : 'green');
  const style = (kind && STYLES[kind]) || { ...FALLBACK, label: status ?? badge ?? '—' };
  return (
    <Badge
      display="inline-flex"
      alignItems="center"
      gap={1.5}
      style={{ backgroundColor: style.bg, color: style.color }}
      borderRadius="full"
      px={2.5}
      py={0.5}
      fontSize="11.5px"
      fontWeight={700}
      textTransform="none"
    >
      <Box w="6px" h="6px" borderRadius="full" style={{ background: style.dot }} />
      {style.label}
    </Badge>
  );
}
